import {
  Box,
  Flex,
  Text,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
} from '@chakra-ui/react';
import React, { useState } from 'react';
import UsersTab from './UsersTab';
import InvitedUsersTab from './InvitedUsersTab';
import analytics from '../../../../segmentTracking';

const Team = () => {
  const [currentUser] = useState(JSON.parse(localStorage.getItem('user')));
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  // Add tracking for tab changes and refresh active tab
  const handleTabChange = (index) => {
    const tabNames = ['Users', 'Invited Users'];
    const tabName = tabNames[index];

    setActiveTabIndex(index);
    // Trigger refresh only for the newly active tab
    setRefreshTrigger((prev) => prev + 1);

    analytics.track(`settings:team:selected${tabName.replace(' ', '')}`, {
      tab: tabName.toLowerCase().replace(' ', '_'),
      userRole: currentUser?.role,
      email: currentUser?.email,
    });
  };

  return (
    <Box width={'65%'} margin={'24px auto 48px'}>
      <Box>
        <Text fontSize={'20px'} fontWeight={'700'}>
          Team Management
        </Text>
        <Flex flexDir={'column'} margin={'10px 0'}>
          <Flex justifyContent={'space-between'} alignItems={'flex-start'}>
            <Box flexBasis={'70%'}>
              <Text
                fontSize={'14px'}
                lineHeight={'20px'}
                fontWeight={'400'}
                color={'#757575'}
                pt={'4px'}
              >
                Manage team members and pending invitations for your institution
              </Text>
            </Box>
          </Flex>
        </Flex>
      </Box>

      <Flex flexDir={'column'} margin={'10px 0'}>
        <Box mt={6}>
          <Tabs
            variant="enclosed"
            index={activeTabIndex}
            onChange={handleTabChange}
          >
            <TabList>
              <Tab>Users</Tab>
              <Tab>Invited Users</Tab>
            </TabList>

            <TabPanels>
              {/* Users Tab */}
              <TabPanel>
                <UsersTab
                  refreshTrigger={activeTabIndex === 0 ? refreshTrigger : 0}
                />
              </TabPanel>

              {/* Invited Users Tab */}
              <TabPanel>
                <InvitedUsersTab
                  refreshTrigger={activeTabIndex === 1 ? refreshTrigger : 0}
                />
              </TabPanel>
            </TabPanels>
          </Tabs>
        </Box>
      </Flex>
    </Box>
  );
};

export default Team;
